import NavBarContent from "@/domain/entities/navbar/NavBarContent";
import SmartLabel from "@/domain/enums/SmartLabel";
import { NavBarContent as NavBarContentMailvista } from "@cs_teamwaydev/mailvista-sdk_react";
import navItemMapper from "./navItemMapper";

const navBarContentMapper = (
    navBarContent: NavBarContentMailvista,
): NavBarContent => {
    const focusNavItem = navBarContent.smartlabelNavItems.find(
        (item) => item.id === SmartLabel.Focus, // TODO : Remove once the dedicated deep focus hook is implemented in the SDK
    );

    return new NavBarContent({
        generalNavItems: navBarContent.generalNavItems.map(navItemMapper),
        unProcessedFocusMailCount: focusNavItem?.itemCount || 0,
        smartlabelNavItems: navBarContent.smartlabelNavItems.map(navItemMapper),
        customviewsNavItems:
            navBarContent.customviewsNavItems.map(navItemMapper),
    });
};

export default navBarContentMapper;
